import React, { useEffect, useState } from 'react'
import PastMedicalHistory from './Components/PastMedicalHistory/PastMedicalHistory'
import SocialHistorySection from './Components/SocialHistorySection/SocialHistorySection'
import FamilyHealthHistory from './Components/FamilyHealthHistory/FamilyHealthHistory'
import { useSelector } from 'react-redux'
import { ServerRequestProtected } from '../../../../../../../../../utils/ServerDataRequest'
import isNull from '../../../../../../../../../utils/NullChecking'
import { enumUtil } from '../../../../../../../../../utils/Enum'
import { FindFirstChild } from '../../../../../../../../../utils/FindMenuOption'

const History = ({expandAll, ...props}) => {
  const { patientID } = props;

  //================== Encounter ===================//
  
  let isViewAllowed = FindFirstChild('Patient', 'Encounter')?.ISView ?? true;
  let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd ?? true;
  let IsDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted ?? true;

  const API_URL = enumUtil.controller.PatientEncounter
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({})
  const [isRecordSaved, setIsRecordSaved] = useState(false)

  const LoadData = () => {
    setData([])
    setIsRecordSaved(false);
    setIsLoading(true);
    ServerRequestProtected(API_URL + "/GetPatientHistory", 'post', {
      "ID" : patientID,
      "TableName": enumUtil.enumAPITableName.PatientHistory,
    })
    .then((response) => {
        setIsLoading(false);
        setData(response)
    }).catch((error) => {
        setIsLoading(false);
    })
  }

  useEffect(()=>{
    if(!isRecordSaved) return;
    LoadData();
  },[isRecordSaved])
    
  useEffect(() => {
    console.log("prop reload Encounter")
    if (!isNull(props.Reload)) {
      let data = props.id
      data.map((item) => {
        if (item.key === 218) {
          LoadData()
        }
      })
      if (data.length === 0) {
        LoadData()
      }
    }
  }, [props.Reload])

  return (
    <div>
        <p className='heading fs-14 pb-1'>HISTORY</p>
        <div className='d-flex flex-column gap-2'>
          <PastMedicalHistory expandAll={expandAll} data={data?.PastMedicalHistory} patientID={patientID} setIsRecordSaved={setIsRecordSaved} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
          <SocialHistorySection expandAll={expandAll} data={data?.SocialHistory} patientID={patientID} setIsRecordSaved={setIsRecordSaved} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
          <FamilyHealthHistory isViewAllowed={isViewAllowed} expandAll={expandAll} data={data?.FamilyHealthHistory?.FamilyHealthHistory} patientID={patientID} setIsRecordSaved={setIsRecordSaved} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
        </div>
    </div>
  )
}

export default History